export default __webpack_public_path__ + "static/media/Rectangle 224.95bcc2fd.png";